import React from 'react';

export default function UUIDField({ value, onChange, mode, config, ...props }) {
    if (mode === "view") return <span>{value}</span>;
    
    return (
        <input 
            type="text" 
            value={value || ""} 
            onChange={e => onChange(e.target.value)} 
            className="form-control"
            placeholder="Enter UUID"
            pattern="[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}"
            {...props}
        />
    );
} 